import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import type { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';
import FieldError from '@/shared/components/FieldError';
import { routes } from '@/shared/routes';
import type { ServerErrors } from '@/shared/utils/fieldErrors';

interface Props<T extends FieldValues> {
  register: UseFormRegister<T>;
  errors: FieldErrors;
  serverErrors: ServerErrors;
}

export default function TermsCheckbox<T extends { termsAccepted: boolean }>({
  register,
  errors,
  serverErrors,
}: Props<T>) {
  return (
    <div>
      <label className="flex items-start gap-3 text-sm text-slate-600">
        <input
          id="termsAccepted"
          type="checkbox"
          className="mt-1 h-4 w-4 rounded border-slate-300 text-brand-600 focus:ring-brand-300"
          {...register('termsAccepted' as Path<T>, { required: true })}
        />
        <span>
          <FormattedMessage id="auth.signUp.termsLabel" values={{ termsLink: legalLink(routes.terms), privacyLink: legalLink(routes.privacy) }} />
        </span>
      </label>
      <FieldError field="termsAccepted" errors={errors} serverErrors={serverErrors}
        messages={{ required: 'auth.signUp.termsRequired' }} />
    </div>
  );
}

function legalLink(to: string) {
  return function renderLink(chunks: ReactNode[]) {
    return (
      <Link to={to} className="font-semibold text-brand-700 hover:text-brand-600">
        {chunks}
      </Link>
    );
  };
}
